import { session } from '@/components/helpers/session'
import { getSearchSpringDomain, getSearchSpringSiteID } from 'libs/searchspring/searchspring-utils'
import { cart } from '@/components/helpers/cart'
import { RANGE_INDICATOR } from '../components/collection/filters/FilterUtils'

/**
 * SearchspringParams
 * ---
 * Class designed to handle standardized formatting for any
 * URL manipulation SS might need for request building.
 * Extends on URLSearch Params.
 */

export class SearchspringParams extends URLSearchParams {
  params
  siteID
  domain

  constructor(category) {
    super()

    this.siteID = getSearchSpringSiteID(category)
    this.domain = getSearchSpringDomain(category)
  }

  setSiteIDParam() {
    this.set('siteId', this.siteID)
    return this
  }

  setDomainParam() {
    this.set('domain', this.domain)
    return this
  }

  setViewedProducts() {
    const viewedProducts = session.viewedProducts.get()
    if (viewedProducts) this.set('lastViewed', viewedProducts)
  }

  setShopperID() {
    const id = session.shopper.get()
    if (id) this.set('shopper', id)
  }

  setUserID() {
    const id = session.userId.get()
    if (id) this.set('userId', id)
  }

  setCartItems() {
    const items = cart?.value?.items
    if (!items) return

    const skus = items.map((item) => item.sku).join(',')
    if (skus) this.set('cart', skus)
  }

  setParams(params) {
    for (const [key, values] of Object.entries(params)) {
      this.set(key, values)
    }
    return this
  }

  setSort(sort) {
    this.clearSort()

    const [field, direction] = sort.split(':')
    const key = `sort.${field}`
    this.set(key, direction)
  }

  clearSort() {
    const keys = Array.from(this.keys())
    for (const key of keys) {
      if (key.startsWith('sort')) {
        this.delete(key)
      }
    }
  }

  setFilters(filters) {
    const keys = Array.from(this.keys())
    for (const key of keys) {
      if (key.startsWith('filter')) {
        this.delete(key)
      }
    }

    if (!filters || !(filters instanceof Set)) {
      return this
    }

    filters.forEach((filter) => {
      if (!filter || typeof filter !== 'string') {
        return
      }

      const parts = filter.split(':')
      if (parts.length < 2) {
        return
      }

      const [field, ...valueParts] = parts
      const value = valueParts.join(':')

      if (!field || !value) {
        return
      }

      const key = `filter.${field}`

      if (value.includes(RANGE_INDICATOR)) {
        const [low, high] = value.split(RANGE_INDICATOR)
        this.append(`${key}.low`, low)
        this.append(`${key}.high`, high)
        return
      }

      this.append(key, value)
    })

    return this
  }
}
